export default `<path fill="currentColor" d="M13.6,8.1V5.8c0-0.9,0.6-1.1,1-1.1c0.4,0,2.5,0,2.5,0V1h-3.4C9.9,1,9.1,3.8,9.1,5.6v2.5H6.9V12h2.2c0,5,0,11,0,11h4.6
c0,0,0-6.1,0-11h3.1l0.4-3.9H13.6z"/>`;
